import { render, staticRenderFns } from "./NavUser.vue?vue&type=template&id=4ba00089&scoped=true&"
import script from "./NavUser.vue?vue&type=script&lang=js&"
export * from "./NavUser.vue?vue&type=script&lang=js&"
import style0 from "./NavUser.vue?vue&type=style&index=0&id=4ba00089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba00089",
  null
  
)

export default component.exports